import { callToActionOptions, customTextOption } from './constants';

export interface CallToActionOption {
  key: string;
  value: string;
}

export const getCustomTextOption: (i18n: any) => CallToActionOption = i18n => ({
  key: customTextOption,
  value: i18n.getString(customTextOption),
});

export const getCallToActionOptions: (i18n: any, withCustomText?: boolean) => CallToActionOption[] = (i18n, withCustomText = true) => {
  const options = [...callToActionOptions];
  if (withCustomText) {
    options.unshift(customTextOption);
  }
  return options.map(option => ({
    key: option,
    value: i18n.getString(option),
  }));
};
